import { booleanAttribute, Component, input } from '@angular/core';
import { ClButton } from '@corelabs/angular/ui';

export type ButtonSeverity = 'primary' | 'secondary' | 'success' | 'info' | 'warn' | 'danger';
export type ButtonVariant = 'outlined' | 'text';
export type ButtonSize = 'small' | 'large';
type ButtonType = 'button' | 'submit' | 'reset';

@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.css'],
    imports: [ClButton],
    // Disabled kills pointer events on the inner button, so the click would land on this host — where the consumer's (click) sits.
    host: { '[style.pointer-events]': "disabled() ? 'none' : null" },
})
export class ButtonComponent {
    /** Color weight; omit for the default primary fill. */
    readonly severity = input<ButtonSeverity>();
    /** Outlined or text style; omit for the default filled style. */
    readonly variant = input<ButtonVariant>();
    /** Omit for the default (normal) size. */
    readonly size = input<ButtonSize>();
    readonly type = input<ButtonType>('button');
    /** Square button for icon-only content; set `ariaLabel` alongside it for the accessible name. */
    readonly iconOnly = input(false, { transform: booleanAttribute });
    readonly disabled = input(false);
    /** Stretch to fill the available width. */
    readonly fluid = input(false, { transform: booleanAttribute });
    /** Accessible name — required when `iconOnly` is set, since there's no text to read. */
    readonly ariaLabel = input<string>();
}
